import React, { useState, useEffect } from 'react';
import PaymentTransferStatus from './PaymentTransferStatus';
import DeliveryStartStatus from '../Supplier/DeliveryStartStatus';
import PaymentRecivedStatus from '../Supplier/PaymentRecivedStatus';

import { escrowAddress, escrowABI, TOKENS, expoURL } from '../../../Contract';
import { ethers } from 'ethers';
import { AuthUserApi } from '../../../utils/api';
import { toast } from 'react-toastify';
import { getEncryptId } from '../../../utils/secure';
import { useAppKitAccount, useAppKitProvider } from '@reown/appkit/react';

const BuyerStatus = ({ order, role }) => {
  const [contract, setContract] = useState(null);
  const [transStatus, setTransStatus] = useState('');
  const [ethersProvider, setEthersProvider] = useState(null);

  const { address, isConnected } = useAppKitAccount();
  const { walletProvider } = useAppKitProvider('eip155');

  useEffect(() => {
    if (walletProvider) {
      const provider = new ethers.providers.Web3Provider(walletProvider);
      setEthersProvider(provider);
    } else {
      setEthersProvider(null);
    }
  }, [walletProvider]);

  const getContract = (address, ABI, provider) => {
    if (!provider) return null;
    const contract = new ethers.Contract(address, ABI, provider);

    return contract.connect(provider.getSigner());
  };

  const cancelDeal = async () => {
    try {
      setTransStatus('Confirm transaction on wallet');

      const tx = await contract.cancelDeal(Number(order.escrowNo || 0));

      setTransStatus('Waiting For Confirmation');

      await tx.wait();

      let values = { escrowStatus: 'Rejected', rejectedBy: role };
      var saveResponse = await AuthUserApi.put(
        `/user/transaction-update/${getEncryptId(order.id)}`,
        values
      );
      const { status, data } = saveResponse;

      if (status === 201 && data.escrow !== undefined) {
        toast.success('Deal Cance Successfully..');
        window.location.reload();
      }
      setTransStatus('Deal Cancelled');
    } catch (err) {
      setTransStatus(err?.error?.data?.message || 'Transaction Reverted');
    }
  };

  const confirmDelivery = async () => {
    try {
      setTransStatus('Confirm transaction on wallet');

      const tx = await contract.confirmDelivery(Number(order.escrowNo || 0));

      setTransStatus('Waiting For Confirmation');

      await tx.wait();

      let values = { escrowStatus: 'Delivered', deliveryDate: new Date() };
      var saveResponse = await AuthUserApi.put(
        `/user/transaction-update/${getEncryptId(order.id)}`,
        values
      );
      const { status, data } = saveResponse;

      if (status === 201 && data.escrow !== undefined) {
        toast.success('Delivery Details Updated Successfully..');
        window.location.reload();
      }

      setTransStatus('Order delivered');
    } catch (err) {
      setTransStatus(err?.error?.data?.message || 'Transaction Reverted');
    }
  };

  useEffect(() => {
    if (isConnected && ethersProvider) {
      setContract(getContract(escrowAddress, escrowABI, ethersProvider));
    } else {
      setContract(null);
    }
  }, [ethersProvider, address, isConnected]);

  return (
    <>
      <PaymentTransferStatus
        cancelDeal={cancelDeal}
        confirmDelivery={confirmDelivery}
        isConnected={isConnected}
        transStatus={transStatus}
        role={role}
        order={order}
      />
    </>
  );
};

export default BuyerStatus;
